import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';
import {
  accountReducer,
  addressReducer,
  amountReducer,
  authLoginReducer,
  authOtpReducer,
  beneficiariesReducer,
  cardReducer,
  channelsReducer,
  contactReducer,
  countryReducer,
  creditAgreementReducer,
  debitsReducer,
  deliveryReducer,
  demographyReducer,
  disclosureReducer,
  employmentReducer,
  expenseReducer,
  identityReducer,
  incomeReducer,
  introductionReducer,
  issueReducer,
  maritalReducer,
  offerReducer,
  onlineUseReducer,
  personaReducer,
  privacyReducer,
  proposalReducer,
  purposeReducer,
  refusedReducer,
  scanDocumentReducer,
  signatureReducer,
  simulatorReducer,
  summaryReducer,
  utmReducer
} from '../../features-stores';
import { classifyReducer } from '../../features-stores/classify';
import { customerReducer } from '../../features-stores/customer';
import { leadReducer } from '../../features-stores/lead';
import { shellReducer } from '../../shell/store';
import { RootActions } from './root.actions';
import { IRootState } from './root.state';

export const initialRootState: IRootState = {
  shell: undefined,
  otp: undefined,
  login: undefined,
  introduction: undefined,
  identity: undefined,
  customer: undefined,
  classify: undefined,
  offer: undefined,
  contact: undefined,
  card: undefined,
  beneficiaries: undefined,
  privacy: undefined,
  address: undefined,
  amount: undefined,
  proposal: undefined,
  debits: undefined,
  persona: undefined,
  employment: undefined,
  purpose: undefined,
  expense: undefined,
  income: undefined,
  country: undefined,
  account: undefined,
  simulator: undefined,
  signature: undefined,
  disclosure: undefined,
  summary: undefined,
  issue: undefined,
  marital: undefined,
  scanDocument: undefined,
  onlineUse: undefined,
  delivery: undefined,
  channels: undefined,
  creditAgreement: undefined,
  refused: undefined,
  lead: undefined,
  demography: undefined,
  utm: undefined,
  root: undefined
};

// export const rootReducerFn = createReducer(initialRootState);
const rootReducerFn = createReducer(
  initialRootState,
  on(RootActions.reset, (state: IRootState, action) => {
    return {
      ...initialRootState
    };
  })
);

export function rootReducer(state: IRootState | undefined, action: Action) {
  return rootReducerFn(state, action);
}

export const rootReducers: ActionReducerMap<IRootState> = {
  shell: shellReducer,
  introduction: introductionReducer,
  otp: authOtpReducer,
  login: authLoginReducer,
  contact: contactReducer,
  amount: amountReducer,
  card: cardReducer,
  beneficiaries: beneficiariesReducer,
  privacy: privacyReducer,
  address: addressReducer,
  proposal: proposalReducer,
  persona: personaReducer,
  employment: employmentReducer,
  debits: debitsReducer,
  purpose: purposeReducer,
  identity: identityReducer,
  customer: customerReducer,
  classify: classifyReducer,
  offer: offerReducer,
  expense: expenseReducer,
  income: incomeReducer,
  country: countryReducer,
  account: accountReducer,
  simulator: simulatorReducer,
  signature: signatureReducer,
  disclosure: disclosureReducer,
  summary: summaryReducer,
  marital: maritalReducer,
  scanDocument: scanDocumentReducer,
  onlineUse: onlineUseReducer,
  delivery: deliveryReducer,
  channels: channelsReducer,
  creditAgreement: creditAgreementReducer,
  refused: refusedReducer,
  lead: leadReducer,
  demography: demographyReducer,
  utm: utmReducer,
  root: rootReducer,
  issue: issueReducer
};
